const POST_LOGIN_PATH_KEY = 'postLoginPath';

const PUBLIC_EXACT_PATHS = new Set([
    '/',
    '/es',
    '/features',
    '/contact',
    '/login',
    '/signup',
    '/account',
]);

/** In-app path a signed-out visit should return to after sign-in. */
export function isReturnableAppPath(pathname: string): boolean {
    if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname.includes('\\')) {
        return false;
    }
    if (pathname.includes('..')) return false;
    if (PUBLIC_EXACT_PATHS.has(pathname)) return false;
    if (
        pathname.startsWith('/register/')
        || pathname.startsWith('/login/')
        || pathname.startsWith('/signup/')
    ) {
        return false;
    }
    return true;
}

function isStoredReturnPath(path: string): boolean {
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('://') || path.includes('\\')) {
        return false;
    }
    const pathname = path.split('?')[0]?.split('#')[0] ?? '';
    return isReturnableAppPath(pathname);
}

/** Remember the page a signed-out person opened, including its query string. */
export function rememberPostLoginPath(pathname: string, search: string): void {
    if (!isReturnableAppPath(pathname)) return;
    try {
        sessionStorage.setItem(POST_LOGIN_PATH_KEY, `${pathname}${search ?? ''}`);
    } catch {
        /* private mode */
    }
}

export function peekPostLoginPath(): string | null {
    try {
        const path = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
        return path && isStoredReturnPath(path) ? path : null;
    } catch {
        return null;
    }
}

/** Read and clear the saved path so a later visit to Home is not pulled back. */
export function consumePostLoginPath(): string | null {
    const path = peekPostLoginPath();
    try {
        sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
    } catch {
        /* ignore */
    }
    return path;
}
